'use client'
import { useLocale } from 'core/components/Locale'
import styles from './index.module.scss'
import cls from 'classnames'
import { useWalletInfo, useSetWalletInfo, useShowNumbers, useSetCoinAll } from 'core/controller/web3/walletStore'
import type { MenuProps } from 'antd'
import { Dropdown } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import ConnectWalletModal from '@/app/[lang]/web3/components/Home/ConnectWalletModal'
import InstallWalletModal from '@/app/[lang]/web3/components/Home/InstallWalletModal'
import { useToCurrency } from 'core/utils/useUtils'
import { useAppSetting } from '@/components/appStore'
import { useHCRouter } from '@/components/HCNextLink'
import { bigNumberTimes, bigNumberAdd, toNonExponential } from 'core/utils'
import { usePostWalletAssetWalletAllTokenBalancesMutation } from 'core/query/yapi/web3/wallet/query'
import { useGetWeb3WalletTokenAllQuery } from 'core/query/yapi/hk-web/Web3Wallet/query'

export default function LinkWallet() {
  const t = useLocale()
  const router = useHCRouter()
  const accountId = useWalletInfo('accountId')
  const walletName = useWalletInfo('walletName')
  const accountName = useWalletInfo('accountName')
  const colorId = useWalletInfo('colorId') || 0
  const setWalletInfo = useSetWalletInfo()
  const showNumbers = useShowNumbers()
  const toCurrency = useToCurrency()
  const setCoinAll = useSetCoinAll()
  const currencySymbol = useAppSetting('currencySymbol')
  const [connectWalletOpen, setConnectWalletOpen] = useState(false)
  const [installWalletOpen, setInstallWalletOpen] = useState(false)
  const { data: coinAllList } = useGetWeb3WalletTokenAllQuery()
  const { mutate, data } = usePostWalletAssetWalletAllTokenBalancesMutation()
  const coinAllData = coinAllList?.data?.data || []

  useEffect(() => {
    if (!accountId) return
    mutate({
      body: {
        accountId: accountId,
      },
    })
  }, [accountId])
  useEffect(() => {
    if (coinAllData.length < 1) return
    setCoinAll(coinAllData)
  }, [coinAllData])
  const totalValue = useMemo(() => {
    if (!data?.data?.data[0]?.tokenAssets || !coinAllData) return 0

    const filtered = data.data.data[0].tokenAssets.filter((item) =>
      coinAllData.some(
        (coin) =>
          item.chainIndex === coin.apiChainIndex &&
          item.tokenAddress.toUpperCase() === coin.contractAddress?.toUpperCase() &&
          item.symbol === coin.tokenSymbol
      )
    )
    const total = filtered.reduce((sum: string | number, item: any) => {
      const tokenPrice = parseFloat(item.tokenPrice) || 0
      const balance = parseFloat(item.balance) || 0
      return bigNumberAdd(sum, toNonExponential(Number(bigNumberTimes(tokenPrice, balance))))
    }, 0)

    return toCurrency(total)
  }, [data, coinAllData, currencySymbol])

  const avatarColors: string[] = [
    '#9D5FE3',
    '#00C087',
    '#FB8C40',
    '#E761AB',
    '#20DAE8',
    '#1190FF',
    '#F5C959',
    '#DC4D7C',
    '#CD4D3F',
    '#C356CF',
  ]

  const items: MenuProps['items'] = [
    {
      key: 'walletAssets',
      icon: <i className="iconfont iconFrame-2"></i>,
      label: <span>{t('ieo_038')}</span>,
    },
    {
      key: 'support',
      icon: <i className="iconfont iconFrame-1"></i>,
      label: <span>{t('header_003')}</span>,
    },
    {
      type: 'divider',
    },
    {
      key: 'disconnect',
      icon: <i className="iconfont iconFrame"></i>,
      label: <span>{t('hotcoinWeb_v1_12_2128889_Disconnect')}</span>,
      danger: true,
    },
  ]

  const handleMenuClick = (e: any) => {
    switch (e.key) {
      case 'walletAssets':
        // getTotalValue()
        break
      case 'support':
        router.push('/support/nav/3?id=26104138846572544&code=26104138845261824')
        break
      case 'disconnect':
        setWalletInfo(null)
        router.push('/web3')
        break
    }
  }

  return (
    <>
      <Dropdown menu={{ items: accountId ? items : [], onClick: handleMenuClick }}>
        <div
          className={cls(styles.linkWallet, {
            [styles.walletInfo]: !!accountId,
            [styles.connectWallet]: !accountId,
          })}
          onClick={() => {
            if (!accountId) {
              setConnectWalletOpen(true)
            }
          }}
        >
          {!accountId ? (
            <>
              <i className="iconfont iconzichan11 f16"></i>
              <span className="f14">{t('hotcoinWeb_v1_12_2128889_ConnectYourWallet')}</span>
            </>
          ) : (
            <>
              <div className={styles.walletLeft}>
                <div className={styles.avatar} style={{ backgroundColor: avatarColors[colorId] }}></div>
                <span className={styles.accountText}>
                  {walletName}-{accountName}
                </span>
              </div>
              <div className={styles.walletRight}>
                <span className={styles.assetsFont}>
                  {showNumbers && totalValue ? `${currencySymbol} ${totalValue}` : '*****'}
                </span>
                <i className="iconfont iconbianzu22 f14"></i>
              </div>
            </>
          )}
        </div>
      </Dropdown>
      <div className={styles.download} onClick={() => setInstallWalletOpen(true)}>
        <i className="iconfont iconxiazai-241 f20" style={{ fontSize: '20px !important' }}></i>
      </div>
      {connectWalletOpen && (
        <ConnectWalletModal visible={connectWalletOpen} onCancel={() => setConnectWalletOpen(false)} />
      )}
      {installWalletOpen && (
        <InstallWalletModal visible={installWalletOpen} onCancel={() => setInstallWalletOpen(false)} />
      )}
    </>
  )
}
